// SessionGuard：订阅全局 QueryClient，捕获任意 query 抛出的 SessionExpiredError
// 后自动 navigate('/login', { from: <current path> })。
// 用法：<SessionGuard><Layout>...</Layout></SessionGuard>

import { useEffect, type ReactNode } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { SessionExpiredError } from "@/api/client";

export function SessionGuard({ children }: { children: ReactNode }) {
  const qc = useQueryClient();
  const router = useRouter();

  useEffect(() => {
    const cache = qc.getQueryCache();
    const unsub = cache.subscribe((event) => {
      if (event.type !== "updated") return;
      const err = event.query.state.error;
      if (err instanceof SessionExpiredError) {
        const from = window.location.pathname + window.location.search;
        // 避免在 /login 循环跳转
        if (!window.location.pathname.startsWith("/login")) {
          router.navigate({ to: "/login", search: { from } });
        }
      }
    });
    return () => unsub();
  }, [qc, router]);

  return <>{children}</>;
}
